import Papa from 'papaparse'

class CSVDownloader {
  constructor() {
    this.init()
  }

  init() {
    // 遅延turbo frame内のボタンにも効くよう、documentへのイベントデリゲーションで処理する
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-csv-download]')
      if (!button) return

      e.preventDefault()
      const tableId = button.getAttribute('data-csv-download')
      const filename = button.getAttribute('data-filename') || 'data.csv'
      const csvDataString = button.getAttribute('data-csv-data')
      this.downloadTableAsCSV(tableId, filename, csvDataString)
    })
  }

  downloadTableAsCSV(tableId, filename, csvDataString) {
    const table = document.getElementById(tableId)
    if (!table) {
      console.error(`Table with id "${tableId}" not found`)
      return
    }

    const data = this.extractTableData(table, csvDataString)
    this.downloadCSV(data, filename)
  }

  extractTableData(table, csvDataString) {
    // JSONデータが埋め込まれている場合はそれを使用
    const csvData = csvDataString || table.getAttribute('data-csv-data')
    if (csvData) {
      try {
        const jsonData = JSON.parse(csvData)
        const data = []
        
        // ヘッダーを追加
        if (jsonData.headers) {
          data.push(jsonData.headers)
        }
        
        // データ行を追加
        if (jsonData.rows) {
          data.push(...jsonData.rows)
        }
        
        return data
      } catch (error) {
        console.error('CSV data parsing error:', error)
        // JSONパースエラーの場合は通常の抽出にフォールバック
      }
    }

    // 通常のテーブル抽出（フォールバック）
    const data = []
    
    // ヘッダー行を取得
    const headerRow = table.querySelector('thead tr')
    if (headerRow) {
      const headers = Array.from(headerRow.querySelectorAll('th')).map(th => 
        this.cleanText(th.textContent)
      )
      data.push(headers)
    }

    // データ行を取得
    const dataRows = table.querySelectorAll('tbody tr')
    dataRows.forEach(row => {
      const cells = Array.from(row.querySelectorAll('td')).map(td => {
        return this.cleanText(td.textContent)
      })
      data.push(cells)
    })

    return data
  }

  cleanText(text) {
    return text.trim().replace(/\s+/g, ' ')
  }

  downloadCSV(data, filename) {
    // papaparseでCSV生成
    const csv = Papa.unparse(data, {
      delimiter: ',',
      header: false,
      skipEmptyLines: true
    })

    // BOMを追加してExcelで正しく開けるようにする
    const BOM = '\uFEFF'
    const blob = new Blob([BOM + csv], { 
      type: 'text/csv;charset=utf-8;' 
    })
    
    // ダウンロードリンクを作成
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    URL.revokeObjectURL(url)
  }
}

// 自動初期化
new CSVDownloader()
